import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-1 _grid-cols-6--m _por-r _rounded--common" }
const _hoisted_2 = { class: "_flex _jc-c _ai-c _col-span-1 _col-span-2--m _pos-r" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "_flexcol _jc-c _ai-c _gap-4 _tac _col-span-4--m _px-3--m _px-6--m" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-hd gfu-hd--h4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $props.projectImageUrl,
        alt: $props.creator,
        class: "_img-of-c gfu-embed__item"
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, _toDisplayString($props.content), 1 /* TEXT */),
      _createElementVNode("div", null, [
        ($props.creator)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString($props.creator), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$format($props.fundsGathered, 'C0', '$')) + "+ raised ", 1 /* TEXT */)
      ])
    ])
  ]))
}